import React from 'react'
import MaskedFormControl from 'react-bootstrap-maskedinput'

export default class Masked extends React.Component {
    constructor(props) {
        super(props);
        // Create a ref for the MaskedFormControl
        this.inputRef = React.createRef();
    }
    handleChange(event){
        this.props.instance[this.props.realName] = event.target.value
        if(this.props.onChange) this.props.onChange(event)
        this.setState({touch:true })
    }

    componentDidMount() {
        // Automatically focus the input if focusOnMount is true
        if (this.props.focusOnMount && this.inputRef?.current &&
            this.inputRef.current.children?.[0]?.tagName === 'INPUT' && this.inputRef.current.children[0].type === 'text') {
            this.inputRef.current.children[0].focus?.();
        }
    }

    render() {
        const { name, required, className, placeholder, instance, value, realName, readOnly, disabled, mask } = this.props;
        return (
            <div ref={this.inputRef}>
            <MaskedFormControl 
                key={name}
                name={name}
                value={value ?? instance[realName]}
                required={required}
                className={className}
                mask={mask}
                readOnly={readOnly}
                placeholder={placeholder}
                disabled={disabled}
                onChange={this.handleChange.bind(this)}
            /></div>
        )
    }
}
